import { inject, Injectable, signal, TemplateRef, Type } from '@angular/core';
import { NbDialogService } from '@nebular/theme';
import { NbDialogConfig } from '@nebular/theme/components/dialog/dialog-config';

@Injectable({ providedIn: 'root' })
export class RightPanelDialogService {
  private readonly realDialog = inject(NbDialogService);
  private readonly _count = signal(0);

  public get currentLevel(): number {
    return this._count();
  }

  public register(): void {
    this._count.update(n => n + 1);
  }

  public unregister(): void {
    this._count.update(n => Math.max(0, n - 1));
  }

  open<T>(content: Type<T> | TemplateRef<T>, userConfig?: Partial<NbDialogConfig<Partial<T> | string>>): ReturnType<NbDialogService['open']> {
    this._count.update(n => n + 1);
    const level = Math.min(this._count(), 5);
    const rightBarClass = `right-bar-${level}`;
    const existingDialogClass = userConfig?.dialogClass || '';

    userConfig = {
      hasBackdrop: true,
      backdropClass: `panel-backdrop-${level}`,
      closeOnBackdropClick: false,
      ...userConfig,
      // DOMTokenList.add() rejects tokens with spaces, so we can't join class names here.
      // Apply right-bar class directly to the pane element after open() when a custom class exists.
      dialogClass: existingDialogClass || rightBarClass,
    };
    const ref = this.realDialog.open(content, userConfig);

    if (existingDialogClass) {
      // The pane is already in the DOM at this point — add the level class directly
      const panes = document.querySelectorAll(`.cdk-overlay-pane.${existingDialogClass}`);
      if (panes.length > 0) {
        panes[panes.length - 1].classList.add(rightBarClass);
      }
    }

    ref.onClose.subscribe({
      next: () => this._count.update(n => Math.max(0, n - 1)),
    });
    return ref;
  }
}
